import React from 'react'
import PropTypes from 'prop-types'

const FormSection = ({title}) => {
  return <div className='form-section'>{title}</div>
}

FormSection.propTypes = {
  title: PropTypes.string.isRequired,
}

export default FormSection
